import { Action, createReducer, on } from '@ngrx/store';

import * as SpinnerActions from '../../actions/spinner/spinner.actions';

export interface ISpinnerState {
  show: boolean;
}

export const initialState: ISpinnerState = {
  show: false,
};

const spinnerReducer = createReducer(
  initialState,
  on(SpinnerActions.openSpinner, () => ({ show: true })),
  on(SpinnerActions.closeSpinner, () => ({ show: false })),
);

export function reducer(state: ISpinnerState | undefined, action: Action) {
  return spinnerReducer(state, action);
}

export const getSpinnerShow = (state: ISpinnerState) => state.show;
